import { render, staticRenderFns } from "./CTableColumnHead.vue?vue&type=template&id=59dfd8d0&scoped=true&"
import script from "./CTableColumnHead.vue?vue&type=script&lang=js&"
export * from "./CTableColumnHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59dfd8d0",
  null
  
)

export default component.exports